export default {
  paged: {
    select:
      'id,year,month,status,currency,budgetAmount,consumedAmount,includedCreditGrantedAmount,includedCreditConsumedAmount,billableAmount,periodStart,periodEnd',
    orderBy: 'year desc, month desc',
  },
};
